import { getAllUsers, getAllRoles, addUser, getUserId, updateUser } from '../../services/permissionManager';
import { notification } from 'antd';
export const permissionManager = {
  namespace: 'permissionManager',
  state: {
    permissions: [],
    userData: [],
    permissionWidths: [],
    roles: [],
  },
  reducers: {
    updateUsers(state, { payload: userData }) {
      return { ...state, userData };
    },
    updatePermissionManagerWidths(state, { payload: permissionWidths }) {
      return { ...state, permissionWidths };
    },
    updateRoles(state, { payload: roles }) {
      return { ...state, roles };
    },
  },
  effects: {
    *pageInit({ payload: { pathParams } }, { put }) {
      yield put({ type: 'fetchUsers' });
    },
    *fetchUsers(emptyPayload, { call, put }) {
      const response = yield call(getAllUsers);
      if (response) {
        yield put({ type: 'updateUsers', payload: response.data });
      }
    },
    *fetchRoles(emptyPayload, { call, put }) {
      const response = yield call(getAllRoles);

      if (response) {
        if (response.status === 403) {
          notification.error({
            message: 'Access Denied',
            description: 'You do not have permission to perform this action.',
          });
          return;
        }
        const roles = response.data.map((role) => ({
          id: role.id,
          name: role.name,
        }));
        yield put({ type: 'updateRoles', payload: roles });
      }
    },
    *addUser({ payload }, { call, put }) {
      // Handle null or undefined payload
      if (!payload) {
        notification.error({
          message: 'No users to add',
          description: 'User input is missing or invalid.',
        });
        return;
      }

      // payload should be an array of user objects: [{ email, userRoles }]
      if (!Array.isArray(payload) || payload.length === 0) {
        notification.error({
          message: 'No users to add',
          description: 'Please provide at least one user.',
        });
        return;
      }

      let allSuccess = true;

      for (const user of payload) {
        if (!user.email || !Array.isArray(user.userRoles) || user.userRoles.length === 0) {
          notification.error({
            message: 'Invalid user data',
            description: `Email and at least one role are required for ${user?.email || 'unknown user'}.`,
          });
          allSuccess = false;
          continue;
        }
        const response = yield call(addUser, {
          emailId: user.email,
          roleIds: user.userRoles,
        });
        if (response) {
          notification.success({
            message: 'User added',
            description: `User ${user.email} added successfully.`,
          });
        } else {
          notification.error({
            message: 'Failed to add user',
            description: `Failed to add ${user.email}: ${response?.message || 'Unknown error'}`,
          });
          allSuccess = false;
        }
      }

      if (allSuccess) {
        yield put({ type: 'fetchUsers' });
      }
    },
    *updateUser({ payload }, { call, put }) {
      const user = yield call(getUserId, payload['email']);
      const response = yield call(updateUser, {
        emailId: payload['email'],
        roleIds: payload['roles'],
        userId: user.data['id'],
      });
      if (response) {
        const usersResponse = yield call(getAllUsers);
        yield put({ type: 'updateUsers', payload: usersResponse.data });
        notification.success({
          message: 'User updated',
          description: 'User roles updated successfully.',
        });
      } else {
        notification.error({
          message: 'Failed to update user',
          description: response?.message || 'An unknown error occurred.',
        });
        console.error('Failed to update user:', response?.message || 'Unknown error');
      }
    },
  },
};
